import React, { useCallback, useEffect, useState } from "react";
import intl from 'react-intl-universal';
import { AutoComplete, Input, Select, Tooltip } from "antd";
import _debounce from "lodash/debounce";
import { DingtalkUserItem } from "@/modules/dingtalk/dtos/userList";
import userIcon from '@/assets/Collaboration/user.svg';
import DingtalkManagementAPI from "@/modules/dingtalk/apis/management";
import "./SearchSelectUser.scss";

export enum SHARE_PERMISSION {
    REMARK = 0,
    VIEW = 1
}
type REMOVE = 2;
type SELECT_ACTION = SHARE_PERMISSION | REMOVE;
const SELECT_ACTION_REMOVE: REMOVE = 2;

export type SelectUserItem = {
    name: string;
    id: string;
    permit: SHARE_PERMISSION;
}

export default function SearchSelectUser({
    onChange,
    children,
}: {
    onChange: (list: SelectUserItem[]) => any;
    children?: JSX.Element;
}) {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState<DingtalkUserItem[]>([]);
    const [permit, setPermit] = useState<SHARE_PERMISSION>(SHARE_PERMISSION.REMARK);
    const [list, setList] = useState([]);

    useEffect(() => {
        onChange(list);
    }, [list])

    const search = useCallback(_debounce(async function (val: string) {
        const { data } = await DingtalkManagementAPI.getUserList({ user_name: val });
        setOptions(data.list);
    }, 300), []);
    function onSearch(val: string) {
        setValue(val);
        search(val);
    }
    function onSelect(val: string, opt) {
        if (list.find((item) => item.name === val)) {
            return;
        }
        list.unshift({ name: val, id: opt.userid, permit });
        setList([...list]);
        setTimeout(() => setValue(''));
    }
    function changeAllowComment(value) {
        setPermit(value);
    }
    function changeItemPermission(index: number, val: SELECT_ACTION) {
        if (val === SELECT_ACTION_REMOVE) {
            list.splice(index, 1);
        } else {
            const item = list[index];
            item.permit = val;
        }
        setList([...list]);
    }
    return (
        <>
            <div className="dd-share__search">
                <AutoComplete
                    className="dd-share__input-wrap"
                    placeholder={'请输入钉钉用户名'}
                    onSearch={onSearch}
                    onSelect={onSelect}
                    options={getOption(options)}
                >
                    <Input className="dd-share__search-input" value={value}></Input>
                </AutoComplete>
                {/* @ts-ignore */}
                <Select
                    className="dd-share__search-select"
                    value={permit}
                    style={{ width: 140 }}
                    onChange={changeAllowComment}
                >
                    <Select.Option value={SHARE_PERMISSION.REMARK}>{intl.get('shareDlg.SharedFileLink.canComment')}</Select.Option>
                    <Select.Option value={SHARE_PERMISSION.VIEW}>{intl.get('shareDlg.SharedFileLink.canView')}</Select.Option>
                </Select>
            </div>
            {/* render prompt */}
            {children}
            <ul className={`dd-share__select-list${children ? ' prompt-err' : ''}`}>
                {list.map((item, index) => (
                    <li className="dd-share__select-item" key={index}>
                        <Tooltip placement="top" title={item.name}>
                            <span>{item.name}</span>
                        </Tooltip>
                        {/* @ts-ignore */}
                        <Select
                            className="dd-share__search-select"
                            value={item.permit}
                            style={{ width: 140 }}
                            onChange={changeItemPermission.bind(null, index)}
                        >
                            <Select.Option value={SHARE_PERMISSION.REMARK}>{intl.get('shareDlg.SharedFileLink.canComment')}</Select.Option>
                            <Select.Option value={SHARE_PERMISSION.VIEW}>{intl.get('shareDlg.SharedFileLink.canView')}</Select.Option>
                            <Select.Option value={SELECT_ACTION_REMOVE}>{intl.get('shareDlg.SharedFileLink.Remove')}</Select.Option>
                        </Select>
                    </li>
                ))}
            </ul>
        </>
    )
}

function getOption(list: DingtalkUserItem[]) {
    return list.map(item => {
        return {
            value: item.user_name,
            userid: item.user_id,
            label: (
                <div className="dd-share__search-option">
                    <img className="dd-share__search-option__avatar" src={item.avatar || userIcon} alt="avatar" />
                    <span className="dd-share__search-option__username">{item.user_name}</span>
                </div>
            ),
        }
    })
};
